var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 520,
    viewBox: "0 0 472 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.287 -39C252.753 95.6755 357.399 231.363 276.435 303.807C226.363 348.612 151.923 325.835 142.398 276.429C124.457 183.458 227.668 120.281 315.873 148.932C373.546 167.663 425.021 212.207 442.342 265.594C486.249 400.89 356.453 582.263 201.213 651.412C120.901 687.177 45.5156 687.667 2 684.469",
    stroke: "#0100C6",
    strokeWidth: 40,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.42185f09ecea0528f341972d4b6c4137.svg";
export { ForwardRef as ReactComponent };